import React from 'react'
import { ApplicationFlowTheme } from '../types'
import useMatchingSkinController from './hooks/use-matching-skin-controller'
import MatchingSkin from './matching-skin'

interface Props {

  /** 完成勾选需要与旧业务跳转对齐时传入总等待时长；未传入时使用默认动画节奏。 */
  completionDuration?: number

  /** 旧业务 Bridge 注入的返回动作，保留渠道特有的回退语义。 */
  onBack: () => void

  /** 已由 channelTemplate 解析出的主题；Container 不读取渠道配置。 */
  theme: ApplicationFlowTheme
}

/**
 * MatchingSkinContainer — 连接等待页本地动画与旧业务回调的展示边界
 * @returns {React.ReactElement} 可直接挂载的匹配等待皮肤
 */
const MatchingSkinContainer: React.FC<Props> = React.memo(({ completionDuration, onBack, theme }) => {
  const controller = useMatchingSkinController(completionDuration)

  return <MatchingSkin model={controller.model} onBack={onBack} theme={theme} />
})

MatchingSkinContainer.displayName = 'MatchingSkinContainer'

export default MatchingSkinContainer
